import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../context/AuthContext';
import Logo from '../components/Logo';
import PasswordInput from '../components/PasswordInput';
import './Auth.css';

export default function AdminLogin() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async event => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await api.post('/auth/admin/login', form);
      login(response.data.token, response.data.user);
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.message || 'Could not sign in.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page auth-page-admin">
      <section className="auth-story">
        <Link className="auth-back" to="/">&larr; Public website</Link>
        <div className="auth-story-copy">
          <span className="auth-kicker">Private administration</span>
          <h1>Secure control for Royal Tower operations.</h1>
          <p>This area contains resident, staff and financial records. Access is restricted to authorized administrators.</p>
        </div>
      </section>
      <main className="auth-panel">
        <div className="auth-card">
          <div className="auth-brand"><Logo size={54} /><div><strong>Royal Tower</strong><span>Administration</span></div></div>
          <div className="auth-heading"><h2>Administrator sign in</h2><p>Enter the private administrator credentials.</p></div>
          {error && <div className="auth-error">{error}</div>}
          <form className="auth-form" onSubmit={handleSubmit}>
            <label>Administrator username<input autoComplete="username" value={form.username} onChange={event => setForm({ ...form, username: event.target.value })} required autoFocus /></label>
            <label>Password<PasswordInput autoComplete="current-password" value={form.password} onChange={event => setForm({ ...form, password: event.target.value })} required /></label>
            <button type="submit" disabled={loading}>{loading ? 'Verifying...' : 'Open administration'}</button>
          </form>
        </div>
      </main>
    </div>
  );
}
